import { HostListener }                          from '@angular/core';
import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

declare var StripeCheckout: any;

export class dmSubPayPeriod {
    SubPayPeriod:      RQService.Ota.GetSubPayPeriodsRow;
    LangID:            number;
    ml:                mlBroker;
    IsSelected:        boolean;
    CSSClass:          string;
    PeriodFrom:        Date;
    PeriodFromDisplay: string;
    PaymentID:         string;

    public SetCSSClass(): void {
        this.CSSClass = 'tb-inactive';

        if (this.SubPayPeriod.NeedsPayment    == 1) { this.CSSClass = 'tb-active'; }
        if (this.SubPayPeriod.PaymentRecieved == 1) { this.CSSClass = 'tb-done';   }

        if (this.IsSelected) { this.CSSClass += ' tb-selected'; }
    }

    constructor(
         pSubPayPeriod: RQService.Ota.GetSubPayPeriodsRow
        ,pLangID:       number
        ,pML:           mlBroker
    ) {
        this.SubPayPeriod      = pSubPayPeriod;
        this.LangID            = pLangID;
        this.ml                = pML;

        this.IsSelected        = false;

        this.PeriodFrom        = new Date(
             this.SubPayPeriod.PeriodYear
            ,this.SubPayPeriod.PeriodMonth
            ,1
        );

        this.PeriodFromDisplay = this.PeriodFrom.toLocaleDateString(
             RQApp.LangCodesByID[this.LangID]
            ,{
                 weekday: 'short'
                ,year:    'numeric'
                ,month:   'short'
                ,day:     'numeric'
            }
        );

        if (this.SubPayPeriod.Amount == 0) {
            this.PaymentID = this.ml.Text('NotRequired' ,'Not Required');
        } else if (this.SubPayPeriod.PaymentRecieved == 0) {
            this.PaymentID = this.ml.Text('Unpaid'      ,'Unpaid');
        } else {
            this.PaymentID = this.SubPayPeriod.StripeID;
        }

        this.SetCSSClass();
    }
}

export class PaymentViewModel {
    ShowAlert:            (pTitle: string, pMessage: string) => void;
    BackToSignIn:         ()                                 => void;
    NewLoading:           (pMessage: string)                 => dmLoading;

    mlText:               MLText;
    app:                  mlBroker;
    ml:                   mlBroker;
    Hotel:                dmHotel;
    LangID:               number;

    StripeID:             string;
    Status:               string;

    Handler:              any;

    Amount:               number;

    SubPayPeriods:        dmSubPayPeriod[];

    SelectedSubPayPeriod: dmSubPayPeriod;

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: ()                                 => void
        ,pShowAlert:    (pTitle: string, pMessage: string) => void
        ,pNewLoading:   (pMessage: string)                 => dmLoading
    ) {
        this.mlText               = pMLText;
        this.LangID               = this.mlText.GetLangID();
        this.app                  = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                   = this.mlText.GetBroker(
            'HotelAreaPayment'
        );

        this.Hotel                = pHotel;
        this.BackToSignIn         = pBackToSignIn;
        this.ShowAlert            = pShowAlert;
        this.NewLoading           = pNewLoading;

        this.StripeID             = '';
        this.Status               = '';

        this.Amount               = 0;

        this.SelectedSubPayPeriod = new dmSubPayPeriod(
             RQService.Ota.PopulateGetSubPayPeriodsRow([])
            ,this.LangID
            ,this.ml
        );

        this.SelectedSubPayPeriod.SubPayPeriod.HotelID         = this.Hotel.HotelID;
        this.SelectedSubPayPeriod.SubPayPeriod.Amount          = 0;
        this.SelectedSubPayPeriod.SubPayPeriod.NeedsPayment    = 0;
        this.SelectedSubPayPeriod.SubPayPeriod.PaymentRecieved = 0;
        this.SelectedSubPayPeriod.SubPayPeriod.ResReceived     = 0;
        this.SelectedSubPayPeriod.SubPayPeriod.PeriodYear      = 1900;
        this.SelectedSubPayPeriod.SubPayPeriod.PeriodMonth     = 1;
        this.SelectedSubPayPeriod.SubPayPeriod.StripeID        = '';

        this.refreshSubPayPeriods();
    }

    private setHandler(): void {
        this.Handler  = StripeCheckout.configure({
             key:    'pk_test_51JPSYHCLBAxK9BcSBjS9OsMObpfGUunlK2Zoj7heIgHpVlU8pxD1T56KXUBhbaFcnzloLwifa3kAGl4tLBaC2kg00050r1Vc9Q'
            ,image:  'https://stripe.com/img/documentation/checkout/marketplace.png'
            ,locale: 'en'
            ,token:  (token: any) => {
                let stripeToken: string = token.id    as string;
                let stripeEmail: string = token.email as string;
                let hotelID:     number = this.Hotel.HotelID;
                let amount:      number = this.Amount * 100;

                let params: any = {
                     stripeToken: stripeToken
                    ,stripeEmail: stripeEmail
                    ,hotelID:     hotelID
                    ,amount:      amount
                };

                console.log('stripe client side handler called');

                this.Status = 'pending';

                RQService.Extensions.MakePayment(params).then((result) => {
                    console.log('stripe server side handler called');

                    let response = result as any;

                    if (response.HasErrorOrException) { return; }

                    let stripeResponse = response.RQueryResult;

                    this.StripeID = stripeResponse[0].StripeID;

                    this.NextStatusPoll();
                });
            }
        });
    }

    private refreshSubPayPeriods(): void {
        this.SubPayPeriods   = [];

        let periodParams     = RQParam.OtaGetSubPayPeriodsParams();

        periodParams.HotelID = this.Hotel.HotelID;

        let loading          = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            RQService.Ota.GetSubPayPeriods(periodParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { return; }

                let periods                 = response.RQueryResult;
                let foundSelection: boolean = false;

                for (let i = 0; i < periods.length; i++) {
                    let period = RQService.Ota.PopulateGetSubPayPeriodsRow(
                        periods[i]
                    );
                
                    console.log('row push');

                    let currentPeriod = new dmSubPayPeriod(
                         period
                        ,this.LangID
                        ,this.ml
                    );

                    if (
                        this.SelectedSubPayPeriod.SubPayPeriod.PeriodYear  == period.PeriodYear
                    &&  this.SelectedSubPayPeriod.SubPayPeriod.PeriodMonth == period.PeriodMonth
                    ) {
                        this.SelectedSubPayPeriod = currentPeriod;

                        currentPeriod.IsSelected  = true;
                        foundSelection            = true;
                    }

                    this.SubPayPeriods.push(currentPeriod);
                }

                if (!foundSelection && this.SubPayPeriods.length > 0) {
                    this.SelectedSubPayPeriod            = this.SubPayPeriods[0];
                    this.SelectedSubPayPeriod.IsSelected = true;
                }

                this.Amount = this.SelectedSubPayPeriod.SubPayPeriod.Amount;

                this.SelectedSubPayPeriod.SetCSSClass();

                this.setHandler();

                loading.Dismiss();
            });
        });
    }

    private clearSubPayPeriod(): void {
        let clearParams = RQParam.OtaClearSubPayPeriodParams();

        clearParams.HotelID     = this.Hotel.HotelID;
        clearParams.PeriodYear  = this.SelectedSubPayPeriod.SubPayPeriod.PeriodYear;
        clearParams.PeriodMonth = this.SelectedSubPayPeriod.SubPayPeriod.PeriodMonth;
        clearParams.StripeID    = this.StripeID;

        RQService.Ota.ClearSubPayPeriod(clearParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            this.StripeID = '';
            this.Status   = '';

            this.refreshSubPayPeriods();
        });
    }

    private pollStatus(pAction: () => void): void {
        let statusParams = RQParam.OtaGetStripePaymentStatusParams();

        statusParams.HotelID  = this.Hotel.HotelID;
        statusParams.StripeID = this.StripeID;

        RQService.Ota.GetStripePaymentStatus(statusParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            let stripeStatus = response.RQueryResult;

            let status = RQService.Ota.PopulateGetStripePaymentStatusRow(
                stripeStatus[0]
            );

            this.Status = status.StripePaymentStatus;

            console.log('stripe status poll: ' + this.Status);

            if      (this.Status == 'pending')   { pAction(); }
            else if (this.Status == 'succeeded') {
                this.clearSubPayPeriod();
            }
        });
    }

    public SelectSubPayPeriod(pSubPayPeriod: dmSubPayPeriod) {
        for (let i: number = 0; i < this.SubPayPeriods.length; i++) {
            let currentPeriod: dmSubPayPeriod = this.SubPayPeriods[i];

            if (
                currentPeriod.SubPayPeriod.PeriodYear  == pSubPayPeriod.SubPayPeriod.PeriodYear
            &&  currentPeriod.SubPayPeriod.PeriodMonth == pSubPayPeriod.SubPayPeriod.PeriodMonth
            ) {
                this.SelectedSubPayPeriod = currentPeriod;

                currentPeriod.IsSelected  = true;

                this.Amount               = currentPeriod.SubPayPeriod.Amount;
            } else {
                currentPeriod.IsSelected  = false;
            }

            currentPeriod.SetCSSClass();
        }

        this.setHandler();
    }

    public NextStatusPoll(): void {
        setTimeout(() => {
            this.pollStatus(() => { this.NextStatusPoll(); });

            return;
        }, 5000);
    }

    public Checkout(e) {
        this.Handler.open({
             name:        'tobook.com'
            ,description: this.ml.Text('PaymentFor', 'Payment for tobook SAAS fees')
            ,amount:      this.Amount * 100
        });

        e.preventDefault();
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }

    @HostListener('window:popstate')
    onPopstate() {
        this.Handler.close();
    }
}


// WEBPACK FOOTER //
// ./src/pages/payment/xv-payment.ts